exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mainAppBar{margin-left:220px;background-color:#333}.menuButton{color:#FAFAFA}.hamburgerIcon{color:white}@media only screen and (max-width: 900px){.placebar{margin-left:0}.mainAppBar{display:block !important;padding:0 !important;margin:0}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/dist/cjs.js!./src/components/NavBar/style.scss
// module id = 6238
// module chunks = 0